import {
  SEND_FORGET_PASSWORD_EMAIL,
  UPDATE_AUTH_USER,
  UPDATE_LOAD_USER,
  SEND_REQUEST_NEW_PASSWORD,
  SEND_REQUEST_NEW_PIN,
  SEND_REQUEST_NEW_GAUTH,
  SET_LAST_STEP,
  SEND_REQUEST_SMS_OTP,
  SMS_VERIFICATION_STEP,
  SET_PHONE_NUMBER,
  SET_NOTIFICATION_COUNT,
  SET_NOTIFICATION_LIST,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  authUser: null,
  loadUser: false,
  send_forget_password_email: false,
  send_request_new_password: false,
  send_request_new_pin: false,
  send_request_new_gauth: false,
  set_last_step: '',
  send_request_sms_otp: false,
  set_sms_verification_step: 'STEP1',
  set_phone_number: '',
  notification_count: 0,
  notification_list: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_AUTH_USER: {
      return {
        ...state,
        authUser: action.payload,
        loadUser: true,
      };
    }
    case UPDATE_LOAD_USER: {
      return {
        ...state,
        loadUser: action.payload,
      };
    }
    case SEND_FORGET_PASSWORD_EMAIL: {
      return {
        ...state,
        send_forget_password_email: action.payload,
      };
    }
    case SEND_REQUEST_NEW_PASSWORD: {
      return {
        ...state,
        send_request_new_password: action.payload,
      };
    }
    case SEND_REQUEST_NEW_PIN: {
      return {
        ...state,
        send_request_new_pin: action.payload,
      };
    }
    case SEND_REQUEST_NEW_GAUTH: {
      return {
        ...state,
        send_request_new_gauth: action.payload,
      };
    }
    case SET_LAST_STEP: {
      return {
        ...state,
        set_last_step: action.payload,
      };
    }
    case SEND_REQUEST_SMS_OTP: {
      return {
        ...state,
        send_request_sms_otp: action.payload,
      };
    }
    case SMS_VERIFICATION_STEP: {
      return {
        ...state,
        set_sms_verification_step: action.payload,
      };
    }
    case SET_PHONE_NUMBER: {
      return {
        ...state,
        set_phone_number: action.payload,
      };
    }
    case SET_NOTIFICATION_COUNT: {
      return {
        ...state,
        notification_count: action.payload,
      };
    }
    case SET_NOTIFICATION_LIST: {
      return {
        ...state,
        notification_list: action.payload,
      };
    }
    default:
      return state;
  }
};
